<style lang="scss" src='./Locator.scss' scoped></style>
<template src="./Locator.html"></template>

<script>
import {
  inRange,
  union,
  max,
  min,
} from 'lodash';
import {
  getSensors,
  getZones,
  saveSensorCommand,
  getCourseBLECommands,
} from '@/api/index';

import CustomTable from '../alerts/components/CustomTable.vue';
import i18n from './../../i18n';

export default {
  name: 'Locator',
  components: {
    CustomTable,
  },
  data() {
    return {
      sensors: [],
      filteredSensors: [],
      zones: [],
      commands: [],
      ranges: [{
          label: '1 - 9',
          range: [1, 9],
          selected: false,
        },
        {
          label: '10 - 18',
          range: [10, 18],
          selected: false,
        },/*
        {
          label: '19 - 27',
          range: [19, 27],
          selected: false,
        },*/
      ],
      loading: {
        sensors: false,
        sensorCommands: false,
      },
      isGolfCourse: false,
      currentSort: 'location_code',
      currentSortOrder: 'desc',
    };
  },
  computed: {
    sensorsSelected: function sensorsSelectedFn() {
      return this.filteredSensors.filter((s) => s.selected).length;
    },
  },
  methods: {
    selectAllFilteredSensors(selected) {
      this.filteredSensors.forEach((s) => {
        s.selected = selected;
      });
    },

    selectAllSensors(selected) {
      this.filteredSensors.forEach((s) => {
        s.selected = selected;
      });
    },
    filterSensors(zoneIds, ranges) {
      this.selectAllSensors(false);
      if (zoneIds.length || ranges.length) {
        this.filteredSensors = this.sensors.filter((s) => (zoneIds.length ? zoneIds.includes(s.zone_id) : true) && (ranges
          .length ? (s.hole && inRange(s.hole.hole_number, min(ranges), max(ranges) + 1)) : true));
      } else {
        this.filteredSensors = this.sensors;
      }
    },
    
    onSelect(sensors) {
      if (sensors && sensors.length && !this.presetSelected) {
        
      }
    },

    customSensorSort(value) {

      if (this.currentSort != 'location_code') {
        return value.sort((a, b) => {
          const sortBy = this.currentSort;
          if (!a[sortBy] && !b[sortBy]) {
            return 0;
          }
          else if (a[sortBy] && !b[sortBy]) {
            return -1;
          } 
          else if (!a[sortBy] && b[sortBy]) {
            return 1;
          } 
          else {
            if (this.currentSortOrder === "desc") {
              return String(a[sortBy]).localeCompare(String(b[sortBy]));
            }
            return String(b[sortBy]).localeCompare(String(a[sortBy]));
          }
          return -1;
        });
      } else {
        return value.sort((a, b) => {
          const sortBy = this.currentSort;
          if (!a['hole_id'] && !b['hole_id']) {
            // no hole, order by location_code
            if (!a[sortBy] && !b[sortBy]) {
              return 0;
            }
            else if (a[sortBy] && !b[sortBy]) {
              return -1;
            } 
            else if (!a[sortBy] && b[sortBy]) {
              return 1;
            } 
            else {
              if (this.currentSortOrder === "desc") {
                  return String(a[sortBy]).localeCompare(String(b[sortBy]));
              }
              return String(b[sortBy]).localeCompare(String(a[sortBy]));
            }
          }
          else if (a['hole_id'] && !b['hole_id']) {
            return -1;
          } 
          else if (!a['hole_id'] && b['hole_id']) {
            return 1;
          } 
          else {
            const holeA = parseInt(a['hole']['hole_number']);
            const holeB = parseInt(b['hole']['hole_number']);

            if (holeA > holeB){
              if (this.currentSortOrder === "desc") {
                return 1;
              }
              return -1;
            } else if (holeB > holeA) {
              if (this.currentSortOrder === "desc") {
                return -1;
              }
              return 1;
            } else {
              if (this.currentSortOrder === "desc") {
                return String(a[sortBy]).localeCompare(String(b[sortBy]));
              }
              return String(b[sortBy]).localeCompare(String(a[sortBy]));
            }
          }
          return -1;
        });
      }
    },

    loadSensors(showLoading) {
      const self = this;
      this.loading.sensors = showLoading;
      getSensors(null).then((res) => {
        const sensorsAux = res.sensors.filter((item) => (
          [self.consts.SensorStatus.DEPLOYED, self.consts.SensorStatus.CHECK].includes(item.status_id)));

        let sensorList = sensorsAux.map((sensor) => {
          if (!sensor.threshold) {
            //  Set default threshold if has not one
            sensor.threshold = {
              ...this.defaultThreshold,
              sensor_id: sensor.sensor_id
            };
          }
          sensor.selected = false;
          return sensor;
        });

        this.sensors = this.customSensorSort(sensorList);
        this.filteredSensors = this.sensors;
        this.loading.sensors = false;
      });
    },

    loadZones() {
        getZones().then((res) => {

          let zones = res.zones.filter(x => !x.hidden);
          
          this.zones = zones.map((zone) => ({
            ...zone,
            selected: false,
          }));
        });
      },

    async loadBLECommands() {
      this.commands = [];
      this.loading.sensorCommands = true;

      await getCourseBLECommands(this.$store.state.course.course_id).then((commands) => {
        this.commands = commands;
      }).finally(() => {
        this.loading.sensorCommands = false;
      });
    },

    async activateBLEMode() {
      const sensorsSelected = this.sensors.filter((s) => s.selected);
      for(let i = 0; i < sensorsSelected.length; i++){
        let attrib = {
          mode: 2, //18 Hours 
        };
        let data = {
            attributes: attrib,
            command: this.consts.CommandType.SET_BLE_MODE,
            sensor_id: sensorsSelected[i].sensor_id
        }
        
        await saveSensorCommand(data)
          .then(() => {
            if (process.env.VUE_APP_SENTRY_ENV == "production") {
              this.$analytics.setCurrentScreen("BLE Locator Activated");
              this.$analytics.logEvent("web_ble_locator_activated");
            }

            this.$notify({
              text: sensorsSelected[i].serial_number + ' ' + i18n.t('locator.success'),
              type: 'success',
            });
          });
      }
      this.loadBLECommands();
    },

    refreshData() {
      this.loadBLECommands();
    },

    getSensorSerial(sensor_id) {
      let sensor = this.sensors.find(x => x.sensor_id == sensor_id);
      if(sensor){
        return sensor.serial_number;
      }
      return '-';
    },
    
    loadData() {
      this.loadSensors(true);
      this.loadZones();
      this.loadBLECommands();
    },
  },
  mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Locator");
      this.$analytics.logEvent("web_locator");
    }
    this.isGolfCourse = 
      ( (this.$store.state.course.facility_type && this.$store.state.course.facility_type.is_golf_course) || !this.$store.state.course.facility_type) 
        ? true : false;
        
    this.loadData();
  },
};

</script>
